<template>
    <div class="klienti-container">
        <div class="container">
            <div class="klienti-heading">
                <h1>Klienti</h1>
            </div>  
        </div>
        <section>
            <div class="container">
                <div class="loreal-heading">
                    <h2>
                        L'Oréal <br>
                        Česká republika
                    </h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus laudantium sit accusantium quidem neque provident voluptas optio perspiciatis molestias dolor porro dicta mollitia nemo modi eligendi quaerat numquam, consequuntur ad.</p>
                </div>
            </div>
            <div>
                <div class="loreal-img-container">
                    <img src="/theme/images/klienti/zendaya-hero.webp" alt="">
                </div>
            </div>
            <div class="container">
                <div class="loreal-text">
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit praesentium eos dolor nulla enim, obcaecati sequi, blanditiis quidem deserunt ut nam ratione quam cumque facilis aspernatur illum quos facere ducimus.</p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi mollitia ab voluptates, fuga possimus omnis ut tempore nisi id accusamus! Molestias, modi. Blanditiis cumque dolorem non nisi labore vel ipsam?</p>
                </div>
                <div class="nums-grid">
                    <div class="num-item">
                        <span class="num">60+</span>
                    </div>
                    <div class="num-item">
                        <span class="num">6+</span>
                    </div>
                    <div class="num-item">
                        <span class="num">7+</span>
                    </div>
                    <div class="num-item">
                        <span class="num">720+</span>
                    </div>
                </div>
            </div>
        </section>
        <klient-medicom></klient-medicom>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from './Footer.vue';
import KlientMedicom from './klienti/KlientMedicom.vue'
    export default {
        components: {
            Footer,
            KlientMedicom
        },
    }
</script>

<style lang="scss" scoped>
.loreal-heading{
    h2{
        font-size: 160px;
        font-weight: 600;
        background: linear-gradient(to right, #CD9F59, #1B4F60);
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text;
    }
    margin-bottom: 90px;
    position: relative;
    p{
        position: absolute;
        top: 55px;
        left: 600px;
        max-width: 460px;
    }
}
.loreal-text{
    max-width: 600px;
}
.loreal-img-container{
    max-width: calc(100% - (100% - 1290px)/2);
    margin-left: auto;
    margin-bottom: 90px;
    @media screen and (max-width: 1440px) {
        max-width: calc(100% - (100% - 1110px)/2);
    }
}
.loreal-img-container img{
    width: 100%;
}
.nums-grid{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    margin-top: 60px;
    .num-item{
        span{
            font-size: 90px;
            font-weight: 600;
        }
    }
}


.klienti-heading{
    margin-bottom: 62px;
}
.klienti-container{
    section{
        margin-bottom: 62px;
    }
}
.klienti-two-items-container{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
    @media screen and (max-width: 992px) {
        display: flex;
        flex-direction: column;
    }
    .klient-item{
        img{
            aspect-ratio: 4 / 3;
        }
    }
}
.klient-item{
    display: flex;
    gap: 25px;
    flex-direction: column;
    img{
        width: 100%;
        border-radius: 25px;
        background-color: #EBEBEB;
        aspect-ratio: 20 / 10;
        object-fit: contain;
        object-position: center;
    }
    a.arrow-btn,
    .arrow-btn{
        width: 90px;
        height: 60px;
        border: solid 1px  black;
        color: black;
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.2;
        .arrow_icon{
            width: 25px;
            height: 25px;
        }
    }
    .klient-text-wrapper{
        display: flex;
        gap: 30%;
        .klient-text{
            h2{
                font-size: 32px;
                margin-bottom: 25px;
            }
        }
        .arrow-btn{
            margin-left: auto;
        }
    }
}
// .klienti-container{
//     padding: 30px;
// }
// .klient-intro{
//     margin-bottom: 60px;
// }
// .klient-intro-grid{
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     @media screen and (max-width: 768px) {
//         grid-template-columns: 1fr;
//     }
// }
// .klient-intro-heading{
//     h2{
//         font-size: 80px;
//         font-weight: 600;
//     }
// }
// .klient-intro-text{
//     p{
//         font-size: 22px;
//         font-weight: 500;
//     }
// }
// .klient-reference{
//     margin-bottom: 120px;
// }
// .klient-refernce-grid{
//     display: grid;
//     grid-template-columns: repeat(4, 1fr);
//     @media screen and (max-width: 992px) {
//         grid-template-columns: repeat(2, 1fr);
//     }
// }
// .klient-reference-item{
//     img{
//         width: 100%;
//         aspect-ratio: 1;
//         object-fit: cover;
//     }
// }
</style>